<template>
    <div class="flex transition items-center">

          <div v-show="isHidden">
            <p>
              <a href="#" v-on:click="isHidden = !isHidden" class="align-middle"><i aria-hidden="true" class="material-icons align-middle mx-1">add_box</i>{{text}}</a>
            </p>
          </div>
          <div v-if="!isHidden" class="flex-1 pr-1">
            <input id="groupCode"
                    type="text"
                   :placeholder="placeholder"
                   @keydown.enter="putItem"
                   v-model="value"
                   :autofocus="'autofocus'"
            />
              <button id="addGroupCode" @click="putItem" type="submit" class="p-0 inline-block w-10 -mr-10"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
              <div class="text-xs bg-orange-300 mt-1 py-1 px-2 rounded"><strong>Note:</strong> Make sure an activity is added under Explore as well.</div>
          </div>
        
      </div>
</template>

<script>
import axios from 'axios'

  export default {

        props: {
            content: '',
            route:'',
            placeholder:'',
            text:'',

        },

        data() {
          return {
            isHidden: true,
            success: false,
            loaded: true,
            value:''
          }
        },

        methods: {
          formfocus() {
              document.getElementById("groupCode").focus();
          },
          mounted(){
            this.formfocus()
          },
          putItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( "#addGroupCode").addClass( "loading" );
              axios.put(this.route,
                {
                    code: this.value
                }
              ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
